var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import UserFeedbackCommentItems from './userFeedbackCommentItems';
import SendCommentFeedback from '../sendCommentFeedback';
import uf from './userFeedback.module.scss';
export const UserFeedbackItems = (_a) => {
    var prop = __rest(_a, []);
    const { userName, userAvatar, id, desc, data, likeCount, like, commentArr, objectHotel: { hotelAvatar, hotelName, rank }, } = prop;
    const [propAr, setPropAr] = useState(commentArr);
    const [likeState, setLikeState] = useState(like);
    const [likeCountState, setLikeCountState] = useState(likeCount);
    const [textComment, setTextComment] = useState('');
    const [open, setOpen] = useState(false);
    const [openCom, setOpenCom] = useState(false);
    const [countComment, setCountComment] = useState(0);
    let commentCount = propAr.length + countComment;
    function timeConverter(UNIX_timestamp) {
        let a = new Date(UNIX_timestamp * 1000);
        let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        let year = a.getFullYear();
        let month = months[a.getMonth()];
        let date = a.getDate();
        let time = date + '/' + month + '/' + year;
        return time;
    }
    const handleSubmit = ev => {
        ev.preventDefault();
        const createText = {
            id: +Date.now().toFixed(),
            desc: ev.target[0].value,
            data: timeConverter(ev.timeStamp),
            likeCount: 0,
            like: false,
            comentOfcoment: [],
        };
        setPropAr([...propAr, createText]);
        setTextComment('');
        setOpenCom(false);
    };
    const feedBackLike = () => {
        setLikeState(!likeState);
        if (!likeState) {
            setLikeCountState(prev => prev + 1);
        }
        if (likeState && likeCountState > 0) {
            setLikeCountState(prev => prev - 1);
        }
    };
    const clickComment = () => {
        setOpenCom(!openCom);
    };
    const closeSendComment = () => {
        setOpenCom(false);
    };
    const clickText = e => {
        if (desc.length > 120) {
            setOpen(!open);
        }
        return;
    };
    return (_jsxs("li", Object.assign({ className: uf.full_container }, { children: [_jsxs("div", Object.assign({ className: `${open ? uf.user_feedback_container_open : uf.user_feedback_container}` }, { children: [_jsxs("div", Object.assign({ className: uf.user_block }, { children: [_jsx("p", Object.assign({ className: uf.user_name }, { children: userName })), _jsxs("div", Object.assign({ className: uf.avatar_block }, { children: [_jsx("img", { className: uf.user_avatar, src: userAvatar, alt: "icon user" }), _jsx("p", Object.assign({ className: uf.user_number }, { children: "36" })), _jsx("p", Object.assign({ className: uf.user_karma }, { children: "Booking Karma" }))] }))] })), _jsxs("div", Object.assign({ className: uf.feedback_block }, { children: [_jsx("p", Object.assign({ className: uf.feedback_area_block }, { children: desc })), _jsxs("div", Object.assign({ className: uf.btn_block }, { children: [_jsx("button", { onClick: clickText, type: "button", className: `${uf.button} ${open ? uf.btn_close_disc : uf.btn_open_disc} ` }), _jsx("button", { onClick: clickComment, type: "button", className: `${uf.btn_open_comment} ${uf.button}` }), _jsx("p", Object.assign({ className: uf.countC }, { children: commentCount > 999 ? '1K' : commentCount > 0 ? commentCount : '' })), _jsx("button", { onClick: () => feedBackLike(id), type: "button", className: `${uf.button} ${likeState ? uf.btn_like : uf.btn_unlike}` }), _jsx("p", Object.assign({ className: uf.countL }, { children: likeCountState > 999 ? '1K' : likeCountState > 0 ? likeCountState : '' })), _jsx("time", Object.assign({ className: uf.time_block, dateTime: "2021-09-11" }, { children: data }))] }))] })), _jsxs("div", Object.assign({ className: uf.user_block }, { children: [_jsx("p", Object.assign({ className: uf.user_name }, { children: hotelName })), _jsxs("div", Object.assign({ className: uf.avatar_block }, { children: [_jsx("img", { className: uf.user_avatar, src: hotelAvatar, alt: "icon hotel" }), _jsx("p", Object.assign({ className: uf.hotel_rank_block }, { children: _jsx("span", Object.assign({ className: uf.hotel_rank }, { children: rank })) }))] }))] }))] })), openCom && propAr.length !== 0 ? (propAr === null || propAr === void 0 ? void 0 : propAr.map(obj => (_jsx(UserFeedbackCommentItems, Object.assign({ obj: obj }, prop, { textComment: textComment, handleSubmit: handleSubmit, setCountComment: setCountComment }), obj.id)))) : openCom ? (_jsx(SendCommentFeedback, { id: id, closeSendComment: closeSendComment, setOpenCom: setOpenCom, textComment: textComment, handleSubmit: handleSubmit })) : null] })));
};
